module.exports = __webpack_public_path__ + "static/img/zs006.761189b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zs006.jpg
// module id = cJUU
// module chunks = 13